"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Polkawatch Distributed Data Pack
 * DDP Development Endpoint/IPFS data pack generation source API
 *
 * The version of the OpenAPI document: 2.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolkawatchApi = exports.PolkawatchApiFactory = exports.PolkawatchApiFp = exports.PolkawatchApiAxiosParamCreator = exports.ChainMetadataBlockAuthoringEnum = exports.ChainMetadataTrackingSystemEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.ChainMetadataTrackingSystemEnum = {
    Tokens: 'tokens',
    Blocks: 'blocks'
};
exports.ChainMetadataBlockAuthoringEnum = {
    Babe: 'babe',
    Aura: 'aura'
};
/**
 * PolkawatchApi - axios parameter creator
 * @export
 */
exports.PolkawatchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutChain: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/ddp/about/chain.json";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns information about the dataset of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDataset: function (lastDays, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsAboutDataset', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsAboutDataset', 'validationType', validationType);
                    localVarPath = "/ddp/about/dataset/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Returns information about the dataset quality of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDatasetQuality: function (lastDays, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsAboutDatasetQuality', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsAboutDatasetQuality', 'validationType', validationType);
                    localVarPath = "/ddp/about/datasetquality/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Identifiers of participating entities. Available only for 60 days and public validation.
         * @param {'region' | 'country' | 'network' | 'operator' | 'validator' | 'pool_operator' | 'pool' | 'nominator'} recordType The record type to get Identifiers from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutInventory: function (recordType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'recordType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsAboutInventory', 'recordType', recordType);
                    localVarPath = "/ddp/about/inventory/{record_type}.json"
                        .replace("{" + "record_type" + "}", encodeURIComponent(String(recordType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} country Country ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsCountryDetail: function (lastDays, validationType, country, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsCountryDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsCountryDetail', 'validationType', validationType);
                    // verify required parameter 'country' is not null or undefined
                    common_1.assertParamExists('ddpIpfsCountryDetail', 'country', country);
                    localVarPath = "/ddp/geography/country/{country}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "country" + "}", encodeURIComponent(String(country)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {3 | 4 | 5} topResults Number of top regions
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsGeoRegionOverview: function (lastDays, topResults, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsGeoRegionOverview', 'lastDays', lastDays);
                    // verify required parameter 'topResults' is not null or undefined
                    common_1.assertParamExists('ddpIpfsGeoRegionOverview', 'topResults', topResults);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsGeoRegionOverview', 'validationType', validationType);
                    localVarPath = "/ddp/geography/overview/{validation_type}/{last_days}/{top_results}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "top_results" + "}", encodeURIComponent(String(topResults)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} network Network ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkDetail: function (lastDays, validationType, network, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNetworkDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNetworkDetail', 'validationType', validationType);
                    // verify required parameter 'network' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNetworkDetail', 'network', network);
                    localVarPath = "/ddp/network/{network}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "network" + "}", encodeURIComponent(String(network)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkOverview: function (lastDays, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNetworkOverview', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNetworkOverview', 'validationType', validationType);
                    localVarPath = "/ddp/network/overview/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30} lastDays Available set of days to query
         * @param {any} nominator Nominator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNominatorDetail: function (lastDays, nominator, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNominatorDetail', 'lastDays', lastDays);
                    // verify required parameter 'nominator' is not null or undefined
                    common_1.assertParamExists('ddpIpfsNominatorDetail', 'nominator', nominator);
                    localVarPath = "/ddp/nominator/{nominator}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "nominator" + "}", encodeURIComponent(String(nominator)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} operator Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorDetail: function (lastDays, validationType, operator, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsOperatorDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsOperatorDetail', 'validationType', validationType);
                    // verify required parameter 'operator' is not null or undefined
                    common_1.assertParamExists('ddpIpfsOperatorDetail', 'operator', operator);
                    localVarPath = "/ddp/operator/{operator}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "operator" + "}", encodeURIComponent(String(operator)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorOverview: function (lastDays, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsOperatorOverview', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsOperatorOverview', 'validationType', validationType);
                    localVarPath = "/ddp/operator/overview/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} pool Pool ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolDetail: function (lastDays, validationType, pool, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolDetail', 'validationType', validationType);
                    // verify required parameter 'pool' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolDetail', 'pool', pool);
                    localVarPath = "/ddp/pool/instance/{pool}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "pool" + "}", encodeURIComponent(String(pool)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} poolOperator Pool Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOperatorDetail: function (lastDays, validationType, poolOperator, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolOperatorDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolOperatorDetail', 'validationType', validationType);
                    // verify required parameter 'poolOperator' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolOperatorDetail', 'poolOperator', poolOperator);
                    localVarPath = "/ddp/pool/operator/{pool_operator}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "pool_operator" + "}", encodeURIComponent(String(poolOperator)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOverview: function (lastDays, validationType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolOverview', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsPoolOverview', 'validationType', validationType);
                    localVarPath = "/ddp/pool/overview/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} region Region ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsRegionDetail: function (lastDays, validationType, region, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsRegionDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsRegionDetail', 'validationType', validationType);
                    // verify required parameter 'region' is not null or undefined
                    common_1.assertParamExists('ddpIpfsRegionDetail', 'region', region);
                    localVarPath = "/ddp/geography/region/{region}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "region" + "}", encodeURIComponent(String(region)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} validator Validator Node ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsValidatorDetail: function (lastDays, validationType, validator, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'lastDays' is not null or undefined
                    common_1.assertParamExists('ddpIpfsValidatorDetail', 'lastDays', lastDays);
                    // verify required parameter 'validationType' is not null or undefined
                    common_1.assertParamExists('ddpIpfsValidatorDetail', 'validationType', validationType);
                    // verify required parameter 'validator' is not null or undefined
                    common_1.assertParamExists('ddpIpfsValidatorDetail', 'validator', validator);
                    localVarPath = "/ddp/validator/{validator}/{validation_type}/{last_days}.json"
                        .replace("{" + "last_days" + "}", encodeURIComponent(String(lastDays)))
                        .replace("{" + "validation_type" + "}", encodeURIComponent(String(validationType)))
                        .replace("{" + "validator" + "}", encodeURIComponent(String(validator)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: common_1.toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * PolkawatchApi - functional programming interface
 * @export
 */
exports.PolkawatchApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.PolkawatchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutChain: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsAboutChain(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about the dataset of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDataset: function (lastDays, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsAboutDataset(lastDays, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns information about the dataset quality of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDatasetQuality: function (lastDays, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsAboutDatasetQuality(lastDays, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Identifiers of participating entities. Available only for 60 days and public validation.
         * @param {'region' | 'country' | 'network' | 'operator' | 'validator' | 'pool_operator' | 'pool' | 'nominator'} recordType The record type to get Identifiers from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutInventory: function (recordType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsAboutInventory(recordType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} country Country ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsCountryDetail: function (lastDays, validationType, country, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsCountryDetail(lastDays, validationType, country, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {3 | 4 | 5} topResults Number of top regions
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsGeoRegionOverview: function (lastDays, topResults, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsGeoRegionOverview(lastDays, topResults, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} network Network ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkDetail: function (lastDays, validationType, network, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsNetworkDetail(lastDays, validationType, network, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkOverview: function (lastDays, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsNetworkOverview(lastDays, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30} lastDays Available set of days to query
         * @param {any} nominator Nominator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNominatorDetail: function (lastDays, nominator, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsNominatorDetail(lastDays, nominator, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} operator Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorDetail: function (lastDays, validationType, operator, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsOperatorDetail(lastDays, validationType, operator, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorOverview: function (lastDays, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsOperatorOverview(lastDays, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} pool Pool ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolDetail: function (lastDays, validationType, pool, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsPoolDetail(lastDays, validationType, pool, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} poolOperator Pool Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOperatorDetail: function (lastDays, validationType, poolOperator, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsPoolOperatorDetail(lastDays, validationType, poolOperator, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOverview: function (lastDays, validationType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsPoolOverview(lastDays, validationType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} region Region ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsRegionDetail: function (lastDays, validationType, region, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsRegionDetail(lastDays, validationType, region, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} validator Validator Node ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsValidatorDetail: function (lastDays, validationType, validator, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ddpIpfsValidatorDetail(lastDays, validationType, validator, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * PolkawatchApi - factory interface
 * @export
 */
exports.PolkawatchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.PolkawatchApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutChain: function (options) {
            return localVarFp.ddpIpfsAboutChain(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about the dataset of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDataset: function (lastDays, validationType, options) {
            return localVarFp.ddpIpfsAboutDataset(lastDays, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns information about the dataset quality of the last N days.
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutDatasetQuality: function (lastDays, validationType, options) {
            return localVarFp.ddpIpfsAboutDatasetQuality(lastDays, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Identifiers of participating entities. Available only for 60 days and public validation.
         * @param {'region' | 'country' | 'network' | 'operator' | 'validator' | 'pool_operator' | 'pool' | 'nominator'} recordType The record type to get Identifiers from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsAboutInventory: function (recordType, options) {
            return localVarFp.ddpIpfsAboutInventory(recordType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} country Country ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsCountryDetail: function (lastDays, validationType, country, options) {
            return localVarFp.ddpIpfsCountryDetail(lastDays, validationType, country, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {3 | 4 | 5} topResults Number of top regions
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsGeoRegionOverview: function (lastDays, topResults, validationType, options) {
            return localVarFp.ddpIpfsGeoRegionOverview(lastDays, topResults, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} network Network ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkDetail: function (lastDays, validationType, network, options) {
            return localVarFp.ddpIpfsNetworkDetail(lastDays, validationType, network, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNetworkOverview: function (lastDays, validationType, options) {
            return localVarFp.ddpIpfsNetworkOverview(lastDays, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30} lastDays Available set of days to query
         * @param {any} nominator Nominator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsNominatorDetail: function (lastDays, nominator, options) {
            return localVarFp.ddpIpfsNominatorDetail(lastDays, nominator, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} operator Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorDetail: function (lastDays, validationType, operator, options) {
            return localVarFp.ddpIpfsOperatorDetail(lastDays, validationType, operator, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsOperatorOverview: function (lastDays, validationType, options) {
            return localVarFp.ddpIpfsOperatorOverview(lastDays, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} pool Pool ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolDetail: function (lastDays, validationType, pool, options) {
            return localVarFp.ddpIpfsPoolDetail(lastDays, validationType, pool, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} poolOperator Pool Operator ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOperatorDetail: function (lastDays, validationType, poolOperator, options) {
            return localVarFp.ddpIpfsPoolOperatorDetail(lastDays, validationType, poolOperator, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsPoolOverview: function (lastDays, validationType, options) {
            return localVarFp.ddpIpfsPoolOverview(lastDays, validationType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} region Region ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsRegionDetail: function (lastDays, validationType, region, options) {
            return localVarFp.ddpIpfsRegionDetail(lastDays, validationType, region, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {30 | 60} lastDays Available set of days to query
         * @param {'public' | 'authority' | 'all'} validationType Limit to Staking Rewards of Public Validators with Identity, Aura Authorities, or include ALL rewards and commissions from All validators/collators
         * @param {any} validator Validator Node ID to request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ddpIpfsValidatorDetail: function (lastDays, validationType, validator, options) {
            return localVarFp.ddpIpfsValidatorDetail(lastDays, validationType, validator, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PolkawatchApi - object-oriented interface
 * @export
 * @class PolkawatchApi
 * @extends {BaseAPI}
 */
var PolkawatchApi = /** @class */ (function (_super) {
    __extends(PolkawatchApi, _super);
    function PolkawatchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsAboutChain = function (options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsAboutChain(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about the dataset of the last N days.
     * @param {PolkawatchApiDdpIpfsAboutDatasetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsAboutDataset = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsAboutDataset(requestParameters.lastDays, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns information about the dataset quality of the last N days.
     * @param {PolkawatchApiDdpIpfsAboutDatasetQualityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsAboutDatasetQuality = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsAboutDatasetQuality(requestParameters.lastDays, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Identifiers of participating entities. Available only for 60 days and public validation.
     * @param {PolkawatchApiDdpIpfsAboutInventoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsAboutInventory = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsAboutInventory(requestParameters.recordType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsCountryDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsCountryDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsCountryDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.country, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsGeoRegionOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsGeoRegionOverview = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsGeoRegionOverview(requestParameters.lastDays, requestParameters.topResults, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsNetworkDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsNetworkDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsNetworkDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.network, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsNetworkOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsNetworkOverview = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsNetworkOverview(requestParameters.lastDays, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsNominatorDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsNominatorDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsNominatorDetail(requestParameters.lastDays, requestParameters.nominator, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsOperatorDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsOperatorDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsOperatorDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.operator, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsOperatorOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsOperatorOverview = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsOperatorOverview(requestParameters.lastDays, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsPoolDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsPoolDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsPoolDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.pool, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsPoolOperatorDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsPoolOperatorDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsPoolOperatorDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.poolOperator, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsPoolOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsPoolOverview = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsPoolOverview(requestParameters.lastDays, requestParameters.validationType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsRegionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsRegionDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsRegionDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.region, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PolkawatchApiDdpIpfsValidatorDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolkawatchApi
     */
    PolkawatchApi.prototype.ddpIpfsValidatorDetail = function (requestParameters, options) {
        var _this = this;
        return exports.PolkawatchApiFp(this.configuration).ddpIpfsValidatorDetail(requestParameters.lastDays, requestParameters.validationType, requestParameters.validator, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PolkawatchApi;
}(base_1.BaseAPI));
exports.PolkawatchApi = PolkawatchApi;
